import { DataTable } from './DataTable'
import { Button, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseRoutineModel } from '../routineModel'
import { DeleteOutlined, NodeIndexOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setAddCarVisible, onDelete, selectedRowKeys } = baseRoutineModel()

    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <NodeIndexOutlined />
                添加路线
            </Button>
            <Button
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        return message.warning('请选择路线进行删除功能！')
                    } else {
                        onDelete(selectedRowKeys)
                    }
                }}
            >
                <DeleteOutlined />
                一键删除
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
